<div
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.borderColor]="textColor | contentBuilderColor"
  class="mt-16"
>
  <div
    class="mx-5 flex flex-grow rounded-lg border border-4 border-solid px-6 py-4"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.borderColor]="textColor | contentBuilderColor"
  >
    <input
      appVirtualKeyboard
      [onlyUpperCase]="true"
      type="text"
      [(ngModel)]="voucher"
      [isOverFooter]="true"
      class="flex flex-grow border border-none text-2xl outline-none focus:outline-none focus:ring-0"
      [placeholder]="'kiosk.cart.promotion.inputPlaceholder' | translate"
      [style.backgroundColor]="backgroundColor | contentBuilderColor"
    />
    <app-button-atom
      size="M"
      thickSize="M"
      [label]="'kiosk.cart.promotion.applyButton' | translate"
      [overrideBgColor]="primaryButtonBackgroundColor"
      [overrideTextColor]="primaryButtonTextColor"
      type="kiosk-primary"
      [full]="true"
      (click)="applyVoucher(voucher)"
    ></app-button-atom>
  </div>
  @if (errorVoucher) {
    <div class="pl-5 pt-5">
      {{ errorVoucher }}
    </div>
  }
  @for (coupon of coupons$ | async; track coupon) {
    <div
      class="m-5 flex justify-between border-b border-neutral-300 px-4 py-6"
      [style.backgroundColor]="primaryButtonTextColor | contentBuilderColor"
      [style.color]="primaryButtonBackgroundColor | contentBuilderColor"
      [class.opacity-50]="coupon.removeInProgress"
    >
      <div class="flex flex-col items-start justify-center leading-snug lg:text-base">
        <div class="text-xl font-bold">
          @if (coupon.name) {
            {{ coupon.name }}
          }
          @if (!coupon.name) {
            {{ 'basket.discount-voucher' | translate }} «{{ coupon.code }}»
          }
        </div>
        @if (coupon.type === 'ERROR') {
          <div class="text-xs text-error-800">
            @if (coupon.error) {
              {{ 'voucher-modal.voucher-not-available' | translate }}
            }
            @if (!coupon.error) {
              {{ 'basket.invalid-voucher' | translate }}
            }
          </div>
        }
        @if (coupon.is_removable) {
          <div>
            <app-button-atom
              size="M"
              thickSize="S"
              [label]="'kiosk.cart.promotion.removeButton' | translate"
              [overrideBgColor]="secondaryButtonBackgroundColor"
              [overrideTextColor]="secondaryButtonTextColor"
              type="kiosk-primary"
              icon="icon-c-remove"
              [full]="true"
              (click)="removeCoupon(coupon)"
            ></app-button-atom>
          </div>
        }
      </div>
      <div class="flex flex-row items-center justify-end">
        @if (coupon.type !== 'ERROR') {
          <div class="icon icon-coupon-3 px-4 text-2xl text-neutral-400"></div>
        }
        @if (coupon.type === 'ERROR') {
          <div class="icon icon-warning-circle px-4 text-error-800"></div>
        }
        @if (coupon.type !== 'ERROR') {
          <div class="w-28 text-right text-2xl leading-5">
            –
            <app-price-atom
              [bold]="false"
              [amount]="coupon.amount_off ?? 0"
              [format]="true"
              [size]="'2XL'"
              legalTextClass="text-lg kiosk-xl:text-xl"
            ></app-price-atom>
          </div>
        }
      </div>
    </div>
  }
</div>
